import { render, staticRenderFns } from "./DevAutomationContractFileManagement.vue?vue&type=template&id=b2c298f6"
import script from "./DevAutomationContractFileManagement.vue?vue&type=script&lang=js"
export * from "./DevAutomationContractFileManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports